/**
 * 全局方法注册
 */
import Vue from 'vue'
import {Loading, Message} from 'element-ui'
import md5 from 'js-md5'
import {generateButton, generateName} from '@/utils/i18n'
import {parseTime} from '@/utils/format/date'

Vue.prototype.$md5 = md5
Vue.prototype.getWindowClientWH = getWindowClientWH
Vue.prototype.getImgUrl = getImgUrl
Vue.prototype.showMessage = showMessage
Vue.prototype.showLoading = showLoading
Vue.prototype.formatterOrder = formatterOrder

Vue.prototype.generateName = generateName
Vue.prototype.generateButton = generateButton
Vue.prototype.guid = guid
Vue.prototype.parseTime = parseTime
Vue.prototype.desensitizedName = desensitizedName
Vue.prototype.desensitizedPhone = desensitizedPhone
Vue.prototype.desensitizedIdNo = desensitizedIdNo

function getImgUrl (url) {
  return 'api/' + url
}

function showLoading (text, lock, spinner, background) {
  return Loading.service({
    lock: lock || true,
    text: text || '加载中',
    spinner: spinner || 'el-icon-loading',
    background: background || 'rgba(0, 0, 0, 0.7)'
  })
}

function showMessage (message, type) {
  Message({
    message: message,
    type: type
  })
}

/*
 * 获取浏览器高宽
 * @returns {{width: number, height: number}}
 */
function getWindowClientWH () {
  let winWidth = 0
  let winHeight = 0
  // 获取窗口宽度
  if (window.innerWidth) {
    winWidth = window.innerWidth
  } else if ((document.body) && (document.body.clientWidth)) {
    winWidth = document.body.clientWidth
  }
  // 获取窗口高度
  if (window.innerHeight) {
    winHeight = window.innerHeight
  } else if ((document.body) && (document.body.clientHeight)) {
    winHeight = document.body.clientHeight
  }
  // 通过深入Document内部对body进行检测，获取窗口大小
  if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
    winHeight = document.documentElement.clientHeight
    winWidth = document.documentElement.clientWidth
  }
  return {
    width: winWidth,
    height: winHeight
  }
}

/*
 * 前台获取的排序不是asc和desc,需要转化后转到后台
 * @param order
 * @returns {string}
 */
function formatterOrder (order) {
  let orderBy = 'desc'
  if (order && order.toString()
                    .startsWith('asc')) {
    orderBy = 'asc'
  }
  return orderBy
}

/**
 * 名字脱敏 保留首位
 * @param fullName
 * @returns {string}
 */
function desensitizedName (fullName) {
  if (!fullName) {
    return ''
  }

  let str = fullName.substr(0, 1)
  for (let i = 0; i < fullName.length - 1; i++) {
    str += '*'
  }

  return str
}
/**
 * 手机号脱敏
 * @param str
 * @returns {string|*|string}
 */
function desensitizedPhone (str) {
  if (!str) {
    return ''
  }
  const phoneReg = /^(1[0-9][0-9])\d{4}(\d{4})$/ // 手机号正则校验
  return str.replace(phoneReg, '$1****$2')
}
/**
 * 身份证号脱敏
 * @param str
 * @returns {string|*|string}
 */
function desensitizedIdNo (str) {
  if (!str) {
    return ''
  }
  const idNoReg = /(\d{6})(\d*)(\w{3})/ // 简易身份证号码正则
  if (idNoReg.test(str)) {
    let text1 = RegExp.$1
    let text3 = RegExp.$3
    let text2 = RegExp.$2.replace(/./g, '*')
    return text1 + text2 + text3
  }
  return str
}

/**
 * 获取guid
 */
export function guid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 字符串转json
 * @param jsonString
 * @param defaultValue
 * @returns {{}}
 */
export function parseJson(jsonString, defaultValue) {
  let json = defaultValue || {}
  try {
    json = JSON.parse(jsonString)
  } catch (e) {
    console.log('json转换出错', e)
  }
  return json
}



// WEBPACK FOOTER //
// ./src/utils/global/function/index.js